import React from "react"
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd"
import { injectIntl } from "react-intl"
import Icon from "../common/icon/icon.component"
import { DOCUMENT_TYPE } from "../state/Constants"
import IntlProps from "../state/helpers/IntlProps"
import { LocationDto } from "../state/location/Location"
import { AdviceDto } from "../state/pricing/Advice"
import { PricingFeeCalculationDto } from "../state/pricing/PricingFeeCalculation"
import { PricingRowDto } from "../state/pricing/PricingRow"
import { TOOGGLE_DESCRIPTION_TYPE } from "../state/pricing/ProductDescription"
import RowCustomStatus from "../state/pricing/rowcustomstatus/RowCustomStatus"
import { UserDto } from "../state/user/User"
import ImagePanelComponent from "./components/ImagePanelComponent"
import PricePanelComponent from "./components/PricePanelComponent"
import ProductInformationComponent from "./components/ProductInformationComponent"
import ProductStatusComponent from "./components/ProductStatusComponent"
import SettingPanelComponent from "./components/SettingPanelComponent"

type OwnProps = {
    item: PricingRowDto
    objectId: string
    className: string
    type: DOCUMENT_TYPE
    dragHandle: DraggableProvidedDragHandleProps
    allowEdit: boolean
    sortable: boolean
    productDescription: TOOGGLE_DESCRIPTION_TYPE
    advice: AdviceDto
    fees: PricingFeeCalculationDto[]
    location:LocationDto
    mainObjectId: string
    showInventoryDetails: boolean
    assignedToUserId:string
    users: UserDto[]
    itemTax: undefined,
    intl: IntlProps
    rowCustomStatuses: RowCustomStatus[]
    onChange:()=>void
    onEditLinkClick: () => void
    onUpdateCallback: () => void
}

const PricingTableBundleItem = (props: OwnProps) => {
    return (
        <div id={props.allowEdit ? "pricingTableItem" : "bundleItemModal"} className={"d-flex flex-wrap pl-1 py-2 "
        + (props.item?.attributes.isDisabled ? " bg-light " : "") }
        data-id={props.item?.id}
        >
            <div id={props.allowEdit ? "startPanel" : "startPanelModal"}>
                <div className={
                    "startPanelBundle quote-item-content justify-content-end pb-2 pl-0 pr-0 d-flex flex-wrap "
                    + (props.allowEdit ? "" : "text-center")} >
                    <div className="ml-3 mt-2 mr-1">
                        <Icon value="angle-right" />
                    </div>
                    <ImagePanelComponent
                        itemId={props.item.id}
                        mainObjectId={props.objectId}
                        type={props.type}
                        sortable={false}
                        allowEdit={false}
                        dragHandle={props.dragHandle}
                        isRowSelected={() => false}
                        intl={props.intl}
                    />
                </div>
                <div id={props.allowEdit ? "productInformation" : "productInformationModal"} className={"quote-item-content px-2 pb-2 d-flex"}>
                    <div className="w-100">
                        <div className={"w-100 d-flex " + (props.showInventoryDetails ? "strong" : "")}>
                            {props.item && <ProductInformationComponent
                                productDescription={props.productDescription}
                                type={props.type}
                                allowEdit={false}
                                editableNotes={true}
                                location={props.location}
                                item={props.item}
                                itemId={props.item.id}
                                mainObjectId={props.mainObjectId}
                                fees={props.fees}
                                advice={props.advice}
                            />}
                        </div>
                    </div>
                </div>
            </div>

            {props.showInventoryDetails && <div id={props.allowEdit ? "middlePanel" : ""} className="d-inline-flex flex-wrap">
                <div id={props.allowEdit ? "productStatus" : "productStatusModal"} className="pb-2 mt-1 d-flex flex-wrap align-items-start">
                    <ProductStatusComponent
                        itemId={props.item.id}
                        mainObjectId={props.mainObjectId}
                        showInventoryDetails={props.showInventoryDetails}
                        location={props.location}
                        type={props.type}
                        allowEdit={props.allowEdit}
                        rowCustomStatuses={props.rowCustomStatuses || []}
                        fee={props.fees || []}
                        stockDocument={undefined}
                        documentStatus={""}
                    />
                </div>
            </div>}

            <div id={props.allowEdit ? "finalPanel" : "finalPanelModal"}>
                {props.item && 
                    <div id={props.allowEdit ? "pricePanel" : "pricePanelModal"}
                        style={{justifyContent:"initial"}}
                        className={"quote-item-content d-flex pb-2 align-items-start"}>
                        <SettingPanelComponent
                            itemId={props.item.id}
                            mainObjectId={props.mainObjectId}
                            isDiscountDisabled={true}
                            shouldEditQuantity={ props.allowEdit}
                            fromShowDetails={props.showInventoryDetails}
                            type={props.type}
                            allowEdit={props.allowEdit}
                            fees={props.fees}
                            advice={props.advice}
                            users={props.users}
                            getTableItemTax={()=>props.itemTax}
                            onEditLinkClick={props.onEditLinkClick}
                            onUpdateCallback={() => props.onUpdateCallback()}
                            onChange={props.onChange}
                            assignedToUserId={props.assignedToUserId}
                            stockDocument={undefined}
                        />
                        <PricePanelComponent
                            itemId={props.item.id}
                            pricingTableId={props.mainObjectId}
                            mainObjectId={props.mainObjectId}
                            type={props.type}
                            shouldEditPrice={props.allowEdit}
                            onUpdateCallback={props.onUpdateCallback}
                            shouldEditQuantity={props.allowEdit}
                            allowEdit={props.allowEdit}
                            syncItemsWithCatalogPrices={false}
                        />
                    </div>}
                <div style={{width:"122px"}}
                    className="pb-2 text-align-right d-flex mt-1 flex-column align-items-end justify-content-start">
                </div>
            </div>
           
        </div>
    )
}


export default injectIntl(PricingTableBundleItem)


// WEBPACK FOOTER //
// ./src/pricing/PricingTableBundleItem.tsx